import { ELEMENT_IMAGE, ELEMENT_P, getEmptyParagraph } from 'bxl-editor'

// only support paragraph and image type right now
class ImageTextAdapter {
  deserialize = (imageText: any) => {
    if (!imageText) return [getEmptyParagraph()]
    if (typeof imageText === 'string') {
      const texts = imageText.split('\n')
      return texts.map(p => {
        return {
          type: ELEMENT_P,
          children: [{ text:  p || '' }],
        }
      })
    } else if (!Array.isArray(imageText.layers)) return [getEmptyParagraph()]
    return imageText.layers.map(layer => {
      if (layer.layerType === 'IMAGE') {
        return {
          type: ELEMENT_IMAGE,
          url: layer.image?.url || '',
          width: layer.image?.width || 0,
          height: layer.image?.height || 0,
          format: layer.image?.format,
          children: [{ text: '' }],
        }
      } else {
        return {
          type: ELEMENT_P,
          children: [{ text:  layer.text?.text || '' }],
        }
      }
    })
  }

  serialize = (value: any) => {
    if (!Array.isArray(value)) return { layers: [{ layerType: 'TEXT', text: { text: '' } }] }
    return {
      layers: value.map(item => {
        if (item.type === ELEMENT_IMAGE) {
          return {
            layerType: 'IMAGE',
            image: {
              url: item.url,
              width: item.width,
              height: item.height,
              format: item.format || 'jpg',
            },
          }
        } else {
          return {
            layerType: 'TEXT',
            text: {
              text: item.children?.[0]?.text || '',
            },
          }
        }
      })
    }
  }
}

export default ImageTextAdapter
